"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var MainContainer = _styledComponents.default.button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  border: 1px solid #e33aa9;\n  border-radius: 50px;\n  font-family: Roboto;\n  font-weight: medium;\n  height: 35px;\n  cursor: pointer;\n  font: normal normal medium Roboto;\n  background: ", ";\n  color: ", ";\n  border-color: ", ";\n  padding: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), function (props) {
  return props[props.typeButton].background;
}, function (props) {
  return props[props.typeButton].color;
}, function (props) {
  return props[props.typeButton].borderColor;
}, function (props) {
  var _props$props$typeButt;

  return (_props$props$typeButt = props[props.typeButton].padding) !== null && _props$props$typeButt !== void 0 ? _props$props$typeButt : "10px 20px";
}, function (props) {
  var _props$props$typeButt2;

  return (_props$props$typeButt2 = props[props.typeButton].fontSize) !== null && _props$props$typeButt2 !== void 0 ? _props$props$typeButt2 : "12px";
}, function (props) {
  var _props$props$typeButt3;

  return (_props$props$typeButt3 = props[props.typeButton].lineHeight) !== null && _props$props$typeButt3 !== void 0 ? _props$props$typeButt3 : "12px";
});

exports.MainContainer = MainContainer;
MainContainer.defaultProps = {
  primary: {
    background: "#e33aa9",
    color: "#ffffff",
    borderColor: "#e33aa9"
  },
  secondary: {
    background: "#ffffff",
    color: "#e33aa9",
    borderColor: "#e33aa9"
  },
  image: {
    background: "#ffffff",
    color: "#262626",
    borderColor: "#f0f0f0",
    padding: "10px",
    fontSize: "14px",
    lineHeight: "14px"
  }
};